import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeLinkModule } from 'se-fe-link'

import { SeHouseholdSetupFeatureAlreadyHaveAccountModule } from '@se-po/se-household-setup-feature-already-have-account'
import { SeHouseholdSetupFeatureAccountInfoModule } from '@se-po/se-household-setup-feature-account-info'
import { SeHouseholdSetupFeatureCreatePasswordModule} from '@se-po/se-household-setup-feature-create-password'
import { SeHouseholdSetupFeatureMatchModule } from '@se-po/se-household-setup-feature-match'
import { SeHouseholdSetupFeatureVerificationModule} from '@se-po/se-household-setup-feature-verification'
import { AccountStoreService, StoreService } from '@se-po/se-household-setup-data-access-store'

import { CreateAccountComponent } from './create-account.component'
import { CreateAccountRoutingModule } from './create-account-routing.module'

@NgModule({
  declarations: [
    CreateAccountComponent,
  ],
  imports: [
    CommonModule,
    CreateAccountRoutingModule,
    SeHouseholdSetupFeatureAlreadyHaveAccountModule,
    SeHouseholdSetupFeatureAccountInfoModule,
    SeHouseholdSetupFeatureCreatePasswordModule,
    SeHouseholdSetupFeatureMatchModule,
    SeHouseholdSetupFeatureVerificationModule,
    SeFeCardModule,
    SeFeLinkModule,
  ],
  providers: [
    {
      provide: StoreService,
      useClass: AccountStoreService,
    },
  ]
})
export class CreateAccountModule { }
